"use client";

import ItemsList from "./ItemList";
import { authMenuItems, unAuthMenuItems } from "./data";

const Menu = ({ isAuth }: { isAuth: boolean }) => {
    const items = isAuth ? authMenuItems : unAuthMenuItems;

    return (
        <div className="flex items-center">
            <ItemsList items={items} />
        </div>
    );
};

export default Menu;
